import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, FieldPath } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';

type OrderByDirection = 'asc' | 'desc';
type WhereFilterOp =
  | '<'
  | '<='
  | '=='
  | '!='
  | '>='
  | '>'
  | 'array-contains'
  | 'in'
  | 'array-contains-any'
  | 'not-in';
export type WhereData = {
  fieldPath: string | FieldPath,
  opStr: WhereFilterOp,
  value: any
}[];

@Injectable({
  providedIn: 'root'
})
export class PaginationService {

  constructor(private afs: AngularFirestore) {
  }

  getCollectionPaginated(
    collectionName: string, sortField: string, sortOrder: OrderByDirection,
    pagesize: number, pageNumber: number, whereData: WhereData) {
    const response = this.generateQuery(collectionName, sortField, sortOrder, pagesize, pageNumber, whereData);

    return response.snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            const id = a.payload.doc.id;
            return { id, ...data };
          });
        })
      );
  }

  getCollectionPaginatedValues(
    collectionName: string, sortField: string, sortOrder: OrderByDirection,
    pagesize: number, pageNumber: number, whereData: WhereData) {
    const response = this.generateQuery(collectionName, sortField, sortOrder, pagesize, pageNumber, whereData);
    return response.valueChanges();
  }

  private generateQuery(
    collectionName: string, sortField: string, sortOrder: OrderByDirection,
    pagesize: number, pageNumber: number, whereData: WhereData): AngularFirestoreCollection {

    switch (whereData.length) {
      case 1:
        return this.afs.collection(
          collectionName,
          ref => ref
            .orderBy(sortField, sortOrder)
            .limit(pagesize)
            .startAfter(pageNumber * pagesize)
            .where(whereData[0].fieldPath, whereData[0].opStr, whereData[0].value)
        );
        break;
      case 2:
        return this.afs.collection(
          collectionName,
          ref => ref
            .orderBy(sortField, sortOrder)
            .limit(pagesize)
            .startAfter(pageNumber * pagesize)
            .where(whereData[0].fieldPath, whereData[0].opStr, whereData[0].value)
            .where(whereData[1].fieldPath, whereData[1].opStr, whereData[1].value)
        );
      case 3:
        return this.afs.collection(
          collectionName,
          ref => ref
            .orderBy(sortField, sortOrder)
            .limit(pagesize)
            .startAfter(pageNumber * pagesize)
            .where(whereData[0].fieldPath, whereData[0].opStr, whereData[0].value)
            .where(whereData[1].fieldPath, whereData[1].opStr, whereData[1].value)
            .where(whereData[2].fieldPath, whereData[2].opStr, whereData[2].value)
        );
      default:
        // code block
        if (sortOrder === 'asc') {
          return this.afs.collection(
            collectionName,
            ref => ref
              .orderBy(sortField, sortOrder)
              .limit(pagesize)
              .startAfter(pageNumber * pagesize)
          );
        } else {
          return this.afs.collection(
            collectionName,
            ref => ref
              .orderBy(sortField, sortOrder)
              .limit(pagesize)
              .endBefore(pageNumber * pagesize)
          );
        }
    }
  }
}
